import { axiosPrivate } from "src/utils/axios";
import { errorHandlerAxios } from "src/utils/utils.js";

/**
 * Fetch pinned nav items for the logged-in user.
 * GET /user/pinned-nav
 *
 * Response shape:
 * {
 *   success: true,
 *   data: [
 *     { title: "Dashboard", path: "/dashboard/main" },
 *     { title: "Transactions", path: "/dashboard/accounts-all-requests" }
 *   ]
 * }
 */
export async function getPinnedNavItems() {
  try {
    const response = await axiosPrivate.get("user/pinned-nav");
    return response.data;
  } catch (error) {
    return errorHandlerAxios(error);
  }
}

/**
 * Save / update the full list of pinned nav items for the logged-in user.
 * POST /user/pinned-nav
 *
 * Payload:
 * {
 *   pinnedItems: [
 *     { title: "Dashboard",    path: "/dashboard/main" },
 *     { title: "Transactions", path: "/dashboard/accounts-all-requests" }
 *   ]
 * }
 *
 * Response shape:
 * {
 *   success: true,
 *   message: "Pinned items updated successfully",
 *   data: { pinnedItems: [...] }
 * }
 */
export async function savePinnedNavItems(pinnedItems) {
  try {
    const response = await axiosPrivate.post("user/pinned-nav", { pinnedItems });
    return response.data;
  } catch (error) {
    return errorHandlerAxios(error);
  }
}

/**
 * Remove a single pinned nav item by path.
 * DELETE /user/pinned-nav
 *
 * Payload:
 * {
 *   path: "/dashboard/main"
 * }
 *
 * Response shape:
 * {
 *   success: true,
 *   message: "Item unpinned successfully"
 * }
 */
export async function removePinnedNavItem(path) {
  try {
    const response = await axiosPrivate.delete("user/pinned-nav", {
      data: { path },
    });
    return response.data;
  } catch (error) {
    return errorHandlerAxios(error);
  }
}
